import { z } from "zod";
import { BUSINESS_UNIT_TYPES } from "../auth/features.js";
/**
 * Raporlama ortak sabitleri (Prompt 22, ADR 0022). Okuma modellerinin satış birimi = iş birimi + "OTHER" (iş birimi bilinmeyen
 * kasa satırı — sessizce başka birime atılmaz, "Diğer" olarak görünür).
 */
export const REPORT_SALES_UNITS = [...BUSINESS_UNIT_TYPES, "OTHER"];
export const reportSalesUnitSchema = z.enum(REPORT_SALES_UNITS);
export const REPORT_SALES_UNIT_LABELS = {
    FUEL: "Akaryakıt",
    LPG: "LPG",
    MARKET: "Market",
    WASH: "Araç yıkama",
    EV: "Elektrikli araç şarjı",
    CAFE: "Kafe",
    RENTAL: "Kiralık alan",
    OTHER: "Diğer",
};
/** Birimin hacim ölçüsü: akaryakıt / LPG litre, şarj kWh, yıkama adet (çalışma); market / kafe hacimsiz (fiş sayısı). */
export const REPORT_VOLUME_UNITS = ["L", "KWH", "COUNT"];
export const reportVolumeUnitSchema = z.enum(REPORT_VOLUME_UNITS);
export const REPORT_VOLUME_UNIT_LABELS = {
    L: "litre",
    KWH: "kWh",
    COUNT: "adet",
};
/** Zamanlanabilir / dışa aktarılabilir raporlar (rapor kaydı — `reporting/report-registry`). */
export const REPORT_KEYS = [
    "DAILY_SALES",
    "STATION_COMPARISON",
    "FUEL_ANALYTICS",
    "PROFITABILITY",
    "FINANCE_OVERVIEW",
    "MAINTENANCE",
];
export const reportKeySchema = z.enum(REPORT_KEYS);
export const REPORT_KEY_LABELS = {
    DAILY_SALES: "Günlük satış özeti",
    STATION_COMPARISON: "İstasyon karşılaştırma",
    FUEL_ANALYTICS: "Akaryakıt analitiği",
    PROFITABILITY: "Kârlılık (ana defter)",
    FINANCE_OVERVIEW: "Nakit ve finans özeti",
    MAINTENANCE: "Bakım ve arıza",
};
export const REPORT_FORMATS = ["XLSX", "PDF"];
export const reportFormatSchema = z.enum(REPORT_FORMATS);
export const REPORT_FORMAT_LABELS = { XLSX: "Excel", PDF: "PDF" };
export const REPORT_FREQUENCIES = ["DAILY", "WEEKLY", "MONTHLY"];
export const reportFrequencySchema = z.enum(REPORT_FREQUENCIES);
export const REPORT_FREQUENCY_LABELS = {
    DAILY: "Günlük (dün)",
    WEEKLY: "Haftalık (geçen hafta)",
    MONTHLY: "Aylık (geçen ay)",
};
/** Tablo belgesi sütun tipleri — Excel sayı biçimi ve PDF gösterimi buna göre (ADR 0022 §13). */
export const TABULAR_COLUMN_TYPES = [
    "TEXT",
    "MONEY",
    "LITRES",
    "QUANTITY",
    "PERCENT",
    "COUNT",
    "DATE",
];
export const tabularColumnTypeSchema = z.enum(TABULAR_COLUMN_TYPES);
//# sourceMappingURL=common.js.map